import React from "react";
import { RouteComponentProps } from "@reach/router";
import { LinkButton } from "components/haven-design";

const ProcessUpdateSuccess: React.FC<RouteComponentProps<{location?: {state?: {enqueued: boolean}}}>> =
({ location }) => (
  <div className="text-center">
    <img
      src="https://hc-images2.s3.amazonaws.com/tada.png"
      style={{ maxWidth: 80, maxHeight: 80, marginBottom: 30 }}
    />

    <div style={{ fontSize: 18 }}>
      {location?.state?.enqueued ? (
        "Your messages have been enqueued for sending."
      ) : (
        "All Done!"
      )}
    </div>

    <LinkButton to="/dash/manager/lists" color="primary" size="S" className="margin-top-xl">
      Back to Dashboard
    </LinkButton>
  </div>
);

export default ProcessUpdateSuccess;
